// Microsoft Clarity custom events for the public tour only (fictional classrooms; see
// docs/SEARCH-ANALYTICS.md). site-analytics.js defines window.clarity on allowed pages;
// elsewhere this is a no-op, and nothing about a real class is ever sent.
type ClarityFn = (command: "event", name: string) => void;

type GtagFn = (command: "event", name: string, params: Record<string, string>) => void;
let demoEngaged = false;

export function clarityEvent(name: string) {
  const clarity = (globalThis as { clarity?: ClarityFn }).clarity;
  if (typeof clarity === "function" && /^[a-z_]{1,40}$/.test(name)) {
    try { clarity("event", name); } catch { /* analytics must never break the page */ }
    // GA4 gets one "demo_engaged" per page load (the first real action in a demo classroom), so the
    // share of visitors who actually try the product can be measured without sending names.
    const gtag = (globalThis as { gtag?: GtagFn }).gtag;
    if (!demoEngaged && typeof gtag === "function") {
      demoEngaged = true;
      try { gtag("event", "demo_engaged", { first_action: name }); } catch { /* analytics must never break the page */ }
    }
  }
}

/** A tour write such as POST /api/classes/:id/scores → "tour_scores" (undo → "tour_undo"). */
export function tourEventName(path: string, method: string): string | null {
  if (method === "GET") return null;
  const rest = /^\/api\/classes\/[^/?]+\/([^?]*)/.exec(path)?.[1] ?? "";
  if (/\/undo$/.test(rest)) return "tour_undo";
  const segment = rest.split("/")[0].replace(/-/g, "_");
  return segment && /^[a-z_]{1,34}$/.test(segment) ? `tour_${segment}` : null;
}
